import { render } from "./RatesTableRow.vue?vue&type=template&id=0ac96cdc"
import script from "./RatesTableRow.vue?vue&type=script&lang=js"
export * from "./RatesTableRow.vue?vue&type=script&lang=js"

import "./RatesTableRow.vue?vue&type=style&index=0&id=0ac96cdc&lang=scss"

import exportComponent from "C:\\Bohdan\\telesim_test\\telesim-admin-panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__